import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router ,NavigationEnd } from '@angular/router';
import { AccountService } from 'src/app/core/api/account.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { AgentService } from '../agent.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-navbar-agent',
  templateUrl: './app-navbar-agent.component.html',
  styleUrls: ['./app-navbar-agent.component.scss'],
  providers: [AuthService]
})
export class AppNavbarAgentComponent implements OnInit {
  userLogin: string | null = null;
  keycloakToken: string | null = null;
  // @Output() toggleAdvancedSearch = new EventEmitter<void>();
  showAdvancedSearch = false;
  keycloackToken: any;
  countries: string[] = [];
  phoneNumberSearchQuery: string = ''; // Bind this to the input field
  disabledSearch: boolean = false;
  private routeSubscription: Subscription;
  constructor( private authService : AuthService , private agentService : AgentService ,  private router: Router , private accountService: AccountService) { }
   
  ngOnInit(): void {
    this.getUserData();
    this.subscribeToRouteChanges();
  }

  onSearch(): void {
    // Call the service method to pass the search query
    this.agentService.setPhoneNumberSearchQuery(this.phoneNumberSearchQuery);
     // Clear the phone number search query after the search
    this.phoneNumberSearchQuery = '';
  }

  getUserData(): void {
    this.accountService.get().subscribe(
      (data) => {
        const isAgent = data.authorities.some((auth: any) => auth.name === 'ROLE_AGENT');
  
        if (isAgent) {
          this.userLogin = data.login; // Store the user's login (email)
          this.keycloakToken = data.keycloackToken; // Store the user's Keycloak token
  
          // Set the token in AgentService
          this.agentService.setKeycloakToken(this.keycloakToken);
  
          // Now you can use the Keycloak token to fetch agent details
          this.agentService.getUserAgentId(this.userLogin).subscribe(
            (agent) => {
              if (agent) {
                console.log('Agent ID:', agent.idAgent);
                console.log('Agent Country',agent.agentCountry);
                this.agentService.setAgentId(agent.idAgent);
                this.agentService.setAgentIdAppareil(agent.idAppareil);
                this.agentService.setAgentCountry(agent.agentCountry);
                console.log(this.agentService.getAgentCountry())
                // Use agent.idAgent for creating new entries or any other logic
              } else {
                console.warn('No agent found for the provided email:', this.userLogin);
              }
            },
            (error) => {
              console.error('Error fetching agent by email:', error);
            }
          );
  
          // Log the Keycloak token using the service method
          // console.log('Keycloak Token:', this.agentService.getKeycloakToken());
        } else {
          console.log('No ROLE_AGENT found in authorities');
        }
      },
      (error) => {
        console.error('Error fetching user data:', error);
      }
    );
  }
  
  subscribeToRouteChanges(): void {
    this.routeSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        console.log('Route changed to:', event.url); // Log the new route
        this.checkRoute(event.url);
      });
  }

  checkRoute(currentRoute: string): void {
    console.log('Current route:', currentRoute);
    this.disabledSearch = currentRoute.includes('/editlead');
  }

  // onToggleAdvancedSearch(): void {
  //   this.showAdvancedSearch = !this.showAdvancedSearch;
  //   this.toggleAdvancedSearch.emit();
  // }

  logout(): void {
    this.authService.logout().subscribe(
      () => {
        // Redirect to the login page after successful logout
        this.router.navigate(['/']);
        // Delete the selected countries and statuses when the agent logs out 
        sessionStorage.removeItem('selectedCountries');
        sessionStorage.removeItem('selectedStatuses');
        sessionStorage.removeItem('selectedCompanyId');
        sessionStorage.removeItem('selectedCompanyName');
        sessionStorage.removeItem('selectedCompanies');
        sessionStorage.removeItem('daysAgo');
        sessionStorage.removeItem('filterDateActive');
        sessionStorage.removeItem('isApplied');
        sessionStorage.removeItem('displayDateRange');     
      },
      (error) => {
        // Handle error if logout fails
        console.error('Logout failed:', error);
      }
    );
  }
}
